// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { omitKeys } from "@hex-insights/core";
import { CourseSection, Employee, TeacherCourseSectionEnrollment } from "../../../Utilities";

export type Base = {
	lateStartDate: TeacherCourseSectionEnrollment["lateStartDate"] | null;
	earlyEndDate: TeacherCourseSectionEnrollment["earlyEndDate"] | null;
	courseSectionID: CourseSection["id"] | null;
	teacherID: Employee["id"] | null;
};

export type Create = Base;

export type CreateRequiredKey = Extract<keyof Create, "courseSectionID" | "teacherID">;

export type CreateSubset<K extends keyof Create = keyof Create> = Pick<Create, CreateRequiredKey | K>;

export const initialCreate: Create = {
	lateStartDate: null,
	earlyEndDate: null,
	courseSectionID: null,
	teacherID: null,
};

export type Detail = Base;

export type DetailSubset<K extends keyof Detail = keyof Detail> = Pick<Detail, K>;

export type CreateInCourseSection = Omit<Create, "courseSectionID">;

export type CreateInCourseSectionRequiredKey = Exclude<CreateRequiredKey, "courseSectionID">;

export type CreateInCourseSectionSubset<K extends keyof CreateInCourseSection = keyof CreateInCourseSection> = Pick<
	CreateInCourseSection,
	CreateInCourseSectionRequiredKey | K
>;

export const blankItemInCourseSection: CreateInCourseSection = omitKeys(initialCreate, ["courseSectionID"]);

export type CreateInTeacher = Omit<Create, "teacherID">;

export type CreateInTeacherRequiredKey = Exclude<CreateRequiredKey, "teacherID">;

export type CreateInTeacherSubset<K extends keyof CreateInTeacher = keyof CreateInTeacher> = Pick<
	CreateInTeacher,
	CreateInTeacherRequiredKey | K
>;

export const blankItemInTeacher: CreateInTeacher = omitKeys(initialCreate, ["teacherID"]);
